import { useState } from 'react'
import PrivacyModal from './PrivacyModal'

export default function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false)

  return (
    <footer className="bg-text py-16 px-6 flex flex-col items-center w-full">
      <div className="w-full max-w-4xl mx-auto flex flex-col items-center text-center">
        {/* Title Area */}
        <div className="mb-8">
          <h3 className="font-rubik text-4xl md:text-5xl font-bold text-white mb-4 tracking-wide">
            מאיה <span className="text-white/50">&amp;</span> הילה
          </h3>
          <p className="text-white/70 text-lg md:text-xl font-light tracking-wide">
            סדנאות לנשים
          </p>
        </div>
        
        {/* Links Area */}
        <div className="mb-12">
          <button
            onClick={() => setIsPrivacyOpen(true)}
            className="px-6 py-2 rounded-full border border-white/20 text-white/60 hover:text-white hover:border-white/50 hover:bg-white/5 transition-all text-sm font-medium tracking-wide shadow-sm"
          >
            מדיניות פרטיות והצהרת נגישות
          </button>
        </div>

        {/* Bottom Bar */}
        <div className="w-full border-t border-white/10 pt-8 flex flex-col items-center gap-4">
          <p className="text-white/70 text-sm tracking-wider font-light">
            &copy; {new Date().getFullYear()} מאיה והילה. כל הזכויות שמורות.
          </p>
          <p className="text-white/60 text-[10px] uppercase tracking-[0.3em]">
            Made with heart
          </p>
        </div>
      </div>

      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
    </footer>
  )
}
